export default "__VITE_ASSET__Ct9Kk8Y4__"